var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("TeamStatusControl", {
        attrs: { subject: _vm.slide.settings.subject, type: "answers" },
        on: { subcommand: _vm.subcommand }
      }),
      _vm._v(" "),
      !_vm.scenario
        ? _c("div", { staticClass: "notice" }, [
            _vm._v("Er is geen scenario geselecteerd.")
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }